module.exports = __webpack_public_path__ + "images/bjpk10.efcd.png";